import { apiFetchJson } from '@wundo/client/api.ts';
import type { CurrentUser } from '@wundo/client/auth.ts';
import type { SlackInstallationResponse } from '@wundo/shared/slackInstallation.ts';

/** Only an organisation's admins link its Slack workspace, and only once Wundo's Slack app is set up. */
export function canLinkSlack(user: CurrentUser | undefined): boolean {
  return (
    Boolean(user?.slack_enabled) &&
    (user?.role === 'admin' || user?.role === 'superadmin')
  );
}

export async function fetchSlackInstallation(): Promise<SlackInstallationResponse> {
  return await apiFetchJson<SlackInstallationResponse>('/slack/installation');
}

/*
 * Hand off to Slack's consent screen. Slack sends the browser back through the
 * API, which returns it to Koppelingen with `?slack=<result>`.
 */
export async function startSlackInstall(): Promise<void> {
  const { url } = await apiFetchJson<{ url: string }>(
    '/slack/installation/actions/start',
    {
      method: 'POST',
    },
  );

  window.location.href = url;
}
